import { render } from "./DemoStatsAndCharts.vue?vue&type=template&id=7c63643d&scoped=true"
import script from "./DemoStatsAndCharts.vue?vue&type=script&lang=js"
export * from "./DemoStatsAndCharts.vue?vue&type=script&lang=js"

import "./DemoStatsAndCharts.vue?vue&type=style&index=0&id=7c63643d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c63643d"]])

export default __exports__